
(() => {
  if (window.drawerDiscountInitialized) return;
  window.drawerDiscountInitialized = true;

  const root = window.Shopify?.routes?.root || '/';
  let busy = false;

  async function refreshDrawer() {
    const response = await fetch(
      `${root}cart?section_id=cart-drawer`,
      { cache: 'no-store' }
    );

    if (!response.ok) throw new Error('Refresh impossible');

    const html = new DOMParser().parseFromString(
      await response.text(),
      'text/html'
    );

    const drawer = document.querySelector('cart-drawer');
    const current = drawer?.querySelector('.drawer__inner');
    const updated = html.querySelector('.drawer__inner');

    if (!current || !updated) {
      throw new Error('Section panier introuvable');
    }

    current.innerHTML = updated.innerHTML;

    const iconResponse = await fetch(
      `${root}?section_id=cart-icon-bubble`,
      { cache: 'no-store' }
    );

    if (iconResponse.ok) {
      const iconHTML = new DOMParser().parseFromString(
        await iconResponse.text(),
        'text/html'
      );

      const newIcon = iconHTML.querySelector('#cart-icon-bubble');
      const oldIcon = document.querySelector('#cart-icon-bubble');

      // On conserve l'élément d'origine et ses écouteurs.
      if (newIcon && oldIcon) {
        oldIcon.innerHTML = newIcon.innerHTML;
      }
    }

    if (typeof initSwiper === 'function') initSwiper();
  }

  async function updateDiscount(codes) {
    const response = await fetch(`${root}cart/update.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        discount: codes.join(',')
      })
    });

    const cart = await response.json();

    if (!response.ok) {
      throw new Error(cart.description || 'Erreur Shopify');
    }

    return cart;
  }

  async function handleDiscount(code, remove = false) {
    if (busy) return;
    busy = true;

    const container = document.querySelector('#DrawerDiscount');
    const message = container?.querySelector('.drawer-discount__message');
    const button = container?.querySelector('[type="submit"]');

    if (button) {
      button.disabled = true;
      button.textContent = 'Patientez...';
    }

    if (message) message.textContent = '';

    try {
      const currentCodes = [
        ...document.querySelectorAll(
          '#DrawerDiscount .drawer-discount__remove'
        )
      ].map(el => el.dataset.discountCode);

      const codes = remove
        ? currentCodes.filter(c => c.toLowerCase() !== code.toLowerCase())
        : [...new Set([...currentCodes, code])];

      await updateDiscount(codes);
      await refreshDrawer();

      const refreshed = document.querySelector('#DrawerDiscount');
      const refreshedMessage = refreshed?.querySelector(
        '.drawer-discount__message'
      );

      const visibleCodes = [
        ...document.querySelectorAll(
          '#DrawerDiscount .drawer-discount__remove'
        )
      ].map(el => el.dataset.discountCode.toLowerCase());

      if (refreshedMessage) {
        if (remove) {
          refreshedMessage.textContent = 'Code promo retiré.';
        } else if (visibleCodes.includes(code.toLowerCase())) {
          refreshedMessage.textContent = 'Code promo appliqué.';
        } else {
          refreshedMessage.textContent =
            'Ce code ne semble pas applicable à votre panier.';
        }
      }

      if (typeof publish === 'function' &&
          typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'drawer-discount'
        });
      }
    } catch (error) {
      console.error('[Drawer Discount]', error);

      const currentMessage = document.querySelector(
        '#DrawerDiscount .drawer-discount__message'
      );

      if (currentMessage) {
        currentMessage.textContent =
          'Impossible de mettre à jour le code promo. Réessayez.';
      }
    } finally {
      busy = false;

      const currentButton = document.querySelector(
        '#DrawerDiscountForm [type="submit"]'
      );

      if (currentButton) {
        currentButton.disabled = false;
        currentButton.textContent = 'Appliquer';
      }
    }
  }

  document.addEventListener('submit', event => {
    if (event.target.id !== 'DrawerDiscountForm') return;

    event.preventDefault();

    const input = event.target.querySelector('#DrawerDiscountCode');
    const code = input?.value.trim();

    if (code) handleDiscount(code);
  });

  document.addEventListener('click', event => {
    const remove = event.target.closest('.drawer-discount__remove');

    if (!remove) return;

    event.preventDefault();
    handleDiscount(remove.dataset.discountCode, true);
  });
})();
